import api from '@/libs/axiosInstance';
import type {
  ApiResponse,
  McpCopublicityReviewResponse,
  McpCopublicityOperationResponse,
} from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const mcpCopublicityKeys = {
  review: (id: string) => ['mcp', 'copublicity', 'review', id] as const,
  operation: (id: string | null) => ['mcp', 'copublicity', 'operation', id] as const,
};
export function useMcpCopublicityReviewQuery(id: string) {
  return useQuery({
    queryKey: mcpCopublicityKeys.review(id),
    queryFn: async () => {
      const response = await api.get<ApiResponse<McpCopublicityReviewResponse>>(
        `/mcp/copublicity/preparations/${id}/review`
      );
      if (!response.data.data) throw new Error('Review unavailable');
      return response.data.data;
    },
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });
}
export function useMcpCopublicityOperationQuery(id: string | null) {
  return useQuery({
    queryKey: mcpCopublicityKeys.operation(id),
    queryFn: async () => {
      const response = await api.get<ApiResponse<McpCopublicityOperationResponse>>(
        `/mcp/copublicity/operations/${id}`
      );
      if (!response.data.data) throw new Error('Operation unavailable');
      return response.data.data;
    },
    enabled: Boolean(id),
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });
}
